import { Wifi } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";

export default function ViewMgtDeviceConfigMQTT({ configuration }: { deviceId?: string | null | undefined, device?: any | undefined | null, configuration?: any | undefined | null }) {
  
  return (
    <ViewMgtDevicePanel title="MQTT" icon={<Wifi size={16} />} fullWidth collapsible collapsed>
      <div className="grid grid-cols-1 gap-0">
        <button>Hekllo</button>
      </div>
    </ViewMgtDevicePanel>
  );
}